/** Modal báo cáo khi mở lại game sau thời gian offline. */
import type { BaoCaoOffline } from '../../core/types.js';
import type { GameController } from '../game-controller.js';
import { dinhDangXu, styleNutChinh } from '../dung-chung.js';

export function BaoCaoOfflineModal(props: { controller: GameController; baoCao: BaoCaoOffline }) {
  const { controller, baoCao } = props;
  const tenMon = (ma: string): string =>
    controller.duLieu.matHang.find((m) => m.ma === ma)?.ten ?? ma;
  const monBan = Object.entries(baoCao.monDaBan).sort((a, b) => b[1] - a[1]);

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 50,
      }}
    >
      <div
        style={{
          background: '#241a0e',
          color: '#f5e9d0',
          border: '1px solid #8a6a3a',
          borderRadius: '12px',
          padding: '20px',
          maxWidth: '420px',
          width: '90%',
        }}
      >
        <h2 style={{ margin: '0 0 10px' }}>🌙 Báo cáo lúc bạn vắng</h2>
        <p style={{ margin: '0 0 8px' }}>
          Vắng {baoCao.gioThucVang.toFixed(1)} giờ thực — cửa hàng chạy {baoCao.gioGameDaChay} giờ
          game với hiệu suất {Math.round(controller.duLieu.offline.hieuSuat * 100)}%.
        </p>
        <ul style={{ margin: '0 0 10px', paddingLeft: '20px', fontSize: '14px' }}>
          <li>Lãi gộp: {dinhDangXu(baoCao.laiGop)}</li>
          <li>Lương: {dinhDangXu(baoCao.luong)}</li>
          <li>XP nhận: {Math.round(baoCao.xp)}</li>
          <li>
            Bán {monBan.reduce((a, [, sl]) => a + sl, 0)} món
            {monBan.length > 0 && ` — chạy nhất: ${tenMon(monBan[0]![0])} (${monBan[0]![1]})`}
          </li>
          {baoCao.monHetHang.length > 0 && (
            <li style={{ color: '#e08a8a' }}>
              Hết hàng sớm: {baoCao.monHetHang.map(tenMon).join(', ')}
            </li>
          )}
          {baoCao.lanChoNo > 0 && <li>Nhà cung cấp cho nợ {baoCao.lanChoNo} lần.</li>}
        </ul>
        <button onClick={() => controller.nhanBaoCaoOffline()} style={styleNutChinh}>
          Nhận
        </button>
      </div>
    </div>
  );
}
